import {
  Component,
  Input,
  OnChanges,
  Optional,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl, FormGroupDirective, NgModel } from '@angular/forms';
import { ValidationError } from 'app/core/validation';

@Component({
  selector: 'validation-errors',
  template:
    '<mat-error *ngFor="let errorMessage of errorMessages">{{ errorMessage }}</mat-error>',
  styles: [':host { display: inline-block; }'],
})
export class ValidationErrorsComponent implements OnChanges {
  @Input() controlName: string;
  @Input() model: NgModel;
  @Input() control: AbstractControl;
  @Input() errors: ValidationError[];

  constructor(@Optional() private formGroup: FormGroupDirective) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['controlName']) {
      this.control = this.formGroup?.form.get(this.controlName);
    }
    if (changes['model']) {
      this.control = this.model?.control;
    }
  }

  get errorMessages(): string[] {
    if (this.errors?.length > 0) {
      return [
        ...this.errors.map((validationError) =>
          validationError.getErrorMessage()
        ),
      ];
    }

    if (!this.control || !this.control.errors || !this.control.touched) {
      return [];
    }

    return Object.keys(this.control.errors).map((key) => {
      const validationError = this.control.errors[key];
      if (validationError instanceof ValidationError) {
        return validationError.getErrorMessage();
      }
      return 'Invalid value';
    });
  }
}
